import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import baseURL from "../../../Url/NodeBaseURL";

const PayablesTable = () => {
  const navigate = useNavigate();
  const [payables, setPayables] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expanded, setExpanded] = useState({});

  useEffect(() => {
    const fetchPayables = async () => {
      try {
        const [purchasesRes, rateCutsRes] = await Promise.all([
          fetch(`${baseURL}/get/purchases`),
          fetch(`${baseURL}/rateCuts`),
        ]);

        if (!purchasesRes.ok || !rateCutsRes.ok) {
          throw new Error("Failed to fetch data");
        }

        const purchases = await purchasesRes.json();
        const rateCuts = await rateCutsRes.json();

        const grouped = purchases.reduce((acc, curr) => {
          const key = `${curr.account_name}-${curr.mobile}`;
          if (!acc[key]) {
            acc[key] = {
              account_name: curr.account_name,
              mobile: curr.mobile,
              invoices: [],
              invoiceSet: new Set(),
              totalRateCut: 0,
              totalBalance: 0,
            };
          }

          if (!acc[key].invoiceSet.has(curr.invoice)) {
            acc[key].invoiceSet.add(curr.invoice);

            const matchingCuts = rateCuts.filter(
              (rc) => rc.invoice === curr.invoice
            );

            const totalRateCut = matchingCuts.reduce(
              (sum, item) => sum + Number(item.rate_cut_amt || 0),
              0
            );

            const totalBalance = matchingCuts.reduce(
              (sum, item) => sum + Number(item.balance_amount || 0),
              0
            );

            if (totalBalance > 0) {
              acc[key].totalRateCut += totalRateCut;
              acc[key].totalBalance += totalBalance;

              acc[key].invoices.push({
                ...curr,
                totalRateCut,
                totalBalance,
                dueDate: curr.bill_date,
              });
            }
          }

          return acc;
        }, {});

        const groupedData = Object.values(grouped)
          .map(({ invoiceSet, ...rest }) => rest)
          .filter((item) => item.totalBalance > 0);
        groupedData.sort((a, b) => b.totalBalance - a.totalBalance);

        setPayables(groupedData);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchPayables();
  }, []);

  const toggleExpand = (key) => {
    setExpanded((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const calculateDelay = (bill_date) => {
    const now = new Date();
    const dueDate = new Date(bill_date);
    const diff = now - dueDate;
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    return days > 0 ? days : 0;
  };

  // Function to handle click on payable row and navigate to purchase page
  // const handlePayableClick = async (account_name, mobile) => {
  //   try {
  //     // Find the first invoice for this account to use for navigation
  //     const accountData = payables.find(
  //       (item) => item.account_name === account_name && item.mobile === mobile
  //     );

  //     if (!accountData || accountData.invoices.length === 0) {
  //       console.error("No invoices found for this account");
  //       return;
  //     }

  //     const firstInvoice = accountData.invoices[0].invoice;
  //     const invoiceMobile = accountData.mobile;

  //     // Fetch purchase details using the first invoice
  //     const response = await axios.get(`${baseURL}/get-purchase-details/${firstInvoice}`);
  //     const details = response.data;

  //     if (!details || !details.repeatedData) {
  //       console.error('No repeatedData found in response:', details);
  //       alert('No purchase details found for the provided invoice number.');
  //       return;
  //     }

  //     // Get today's date in yyyy-mm-dd format
  //     const today = new Date().toISOString().split('T')[0];

  //     // Update repeatedData with today's date
  //     const formattedDetails = details.repeatedData.map((item) => ({
  //       ...item,
  //       date: today,
  //       invoice: firstInvoice,
  //     }));

  //     // Store in localStorage (similar to PurchaseTable.js)
  //     localStorage.setItem('tableData', JSON.stringify(formattedDetails));

  //     console.log('Updated purchase details added to localStorage:', formattedDetails);

  //     // Navigate to the purchase page with state
  //     navigate('/purchase', {
  //       state: {
  //         invoice: firstInvoice,
  //         mobile: invoiceMobile,
  //         tableData: details,
  //       },
  //     });

  //   } catch (error) {
  //     console.error('Error fetching purchase details:', error);
  //     alert('Error fetching purchase details. Please try again.');
  //   }
  // };
  const handlePayableClick = async (account_name, mobile, invoice) => {
    try {
      // Find the account data first
      const accountData = payables.find(
        (item) => item.account_name === account_name && item.mobile === mobile
      );

      if (!accountData || accountData.invoices.length === 0) {
        console.error("No invoices found for this account");
        return;
      }

      // ✅ Filter only the clicked invoice
      const selectedInvoice = accountData.invoices.find(
        (inv) => inv.invoice === invoice
      );

      if (!selectedInvoice) {
        console.error("Selected invoice not found for this account");
        alert("Invoice not found for this account");
        return;
      }

      const invoiceNumber = selectedInvoice.invoice;
      const invoiceMobile = accountData.mobile;

      //Fetch purchase details using the clicked invoice number
      const response = await axios.get(`${baseURL}/get-purchase-details/${invoiceNumber}`);
      const details = response.data;

      if (!details || !details.repeatedData) {
        console.error("No repeatedData found in response:", details);
        alert("No purchase details found for the provided invoice number.");
        return;
      }

      // Get today's date in yyyy-mm-dd format
      const today = new Date(
        new Date().getTime() + (5.5 * 60 * 60 * 1000)
      ).toISOString().split("T")[0];


      // Update repeatedData with today's date
      const formattedDetails = details.repeatedData.map((item) => ({
        ...item,
        date: today,
        invoice: invoiceNumber,
      }));

      // Store in localStorage (similar to PurchaseTable.js)
      localStorage.setItem("tableData", JSON.stringify(formattedDetails));

      console.log("Updated purchase details added to localStorage:", formattedDetails);

      // Navigate to the purchase page with state
      navigate("/purchase", {
        state: {
          invoice: invoiceNumber,
          mobile: invoiceMobile,
          tableData: details,
        },
      });
    } catch (error) {
      console.error("Error fetching purchase details:", error);
      alert("Error fetching purchase details. Please try again.");
    }
  };


  if (loading)
    return <div style={{ padding: 10, textAlign: "center" }}>Loading...</div>;
  if (error)
    return (
      <div style={{ padding: 10, color: "red", textAlign: "center" }}>
        {error}
      </div>
    );

  return (
    <div
      style={{
        maxHeight: "200px",
        overflowY: "auto",
        width: "100%",
        marginTop: "8px",
      }}
    >
      <table
        style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}
      >
        <thead>
          <tr
            style={{ backgroundColor: "#f5f5f5", position: "sticky", top: 0 }}
          >
            <th
              style={{
                padding: "6px 10px",
                textAlign: "left",
                fontWeight: "600",
                color: "#b77318",
              }}
            >
              Account Name
            </th>
            <th
              style={{
                padding: "6px 10px",
                textAlign: "right",
                fontWeight: "600",
                color: "#b77318",
              }}
            >
              Payables
            </th>
          </tr>
        </thead>
        <tbody>
          {payables.map((item, idx) => {
            const key = `${item.account_name}-${item.mobile}`;
            const isOpen = expanded[key];
            return (
              <React.Fragment key={key}>
                <tr
                  style={{ 
                    borderBottom: "1px solid #eee", 
                    cursor: "pointer",
                    transition: "background-color 0.2s"
                  }}
                  onClick={(e) => {
                    // Prevent navigation when clicking on expand/collapse arrow
                    if (e.target.textContent.includes("▼") || e.target.textContent.includes("▶")) {
                      toggleExpand(key);
                    } else {
                      handlePayableClick(item.account_name, item.mobile);
                    }
                  }}
                  onMouseEnter={(e) => {
                    e.target.parentElement.style.backgroundColor = "#f8f9fa";
                  }}
                  onMouseLeave={(e) => {
                    e.target.parentElement.style.backgroundColor = "transparent";
                  }}
                >
                  <td
                    style={{
                      padding: "6px 10px",
                      textAlign: "left",
                      maxWidth: "150px",
                    }}
                  >
                    {isOpen ? "▼" : "▶"} {item.account_name}
                  </td>
                  <td
                    style={{
                      padding: "6px 10px",
                      textAlign: "right",
                      color: "#d32f2f",
                      fontWeight: "500",
                    }}
                  >
                    ₹{item.totalBalance.toFixed(2)}
                  </td>
                </tr>

                {isOpen && (
                  <tr>
                    <td colSpan={2} style={{ padding: "0px 10px" }}>
                      <table
                        style={{
                          width: "100%",
                          fontSize: "12px",
                          backgroundColor: "#f9f9f9",
                          marginTop: "5px",
                        }}
                      >
                        <thead>
                          <tr style={{ borderBottom: "1px solid #ccc" }}>
                            <th style={{ textAlign: "left", padding: "6px" }}>
                              Invoice Number
                            </th>
                            <th style={{ textAlign: "right", padding: "6px" }}>
                              Balance Amount (₹)
                            </th>
                            <th style={{ textAlign: "right", padding: "6px" }}>
                              Due Date
                            </th>
                            <th style={{ textAlign: "right", padding: "6px" }}>
                              Delayed (Days)
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {item.invoices.map((inv, i) => (
                            <tr 
                              key={`inv-${i}`}
                              style={{ 
                                cursor: "pointer",
                                transition: "background-color 0.2s"
                              }}
                              onClick={() => handlePayableClick(item.account_name, item.mobile, inv.invoice)}
                              onMouseEnter={(e) => {
                                e.target.parentElement.style.backgroundColor = "#e9ecef";
                              }}
                              onMouseLeave={(e) => {
                                e.target.parentElement.style.backgroundColor = "transparent";
                              }}
                            >
                              <td style={{ padding: "6px" }}>{inv.invoice}</td>
                              <td
                                style={{ padding: "6px", textAlign: "right" }}
                              >
                                ₹{Number(inv.totalBalance || 0).toFixed(2)}
                              </td>
                              <td
                                style={{ padding: "6px", textAlign: "right" }}
                              >
                                {inv.dueDate
                                  ? new Date(inv.dueDate).toLocaleDateString()
                                  : "-"}
                              </td>
                              <td
                                style={{ padding: "6px", textAlign: "right" }}
                              >
                                {`${calculateDelay(inv.dueDate)} days`}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PayablesTable;
